/* eslint-disable max-len */
import React, { useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import * as echarts from 'echarts';
import { IAgriAlertTranslateResModel, IGetHistoricalOrForecastDataResModel } from '@/util/Request/agrialert/responseType';
import { AgregationEnum, SpeedUnitEnum, HistoricalOrForecastEnum } from '@/page/Agrialert/template-management/template-management';

import { WindOrWeatherSelectEnum } from '../template-forecast/template-forecast';
import griddedHistorical from '@/resource/icon-png/griddedNew.png';
import {
    getWeatherImage,
    Daily1,
    Daily2,
    Daily3,
    Daily4,
    Daily5,
    Daily6,
    Daily7,
    Daily8,
    Daily9,
    Daily10,
    Daily11,
    Daily12,
    Daily13,
    Daily14,
    Daily15,
    Daily16,
    Daily17,
    Hourly1Day,
    Hourly1Night,
    Hourly2Day,
    Hourly2Night,
    Hourly3Day,
    Hourly3Night,
    Hourly4Day,
    Hourly4Night,
    Hourly5Day,
    Hourly5Night,
    Hourly6Day,
    Hourly6Night,
    Hourly7Day,
    Hourly7Night,
    Hourly8Day,
    Hourly8Night,
    Hourly9Day,
    Hourly9Night,
    Hourly10Day,
    Hourly10Night,
    Hourly11Day,
    Hourly11Night,
    Hourly12Day,
    Hourly12Night,
    Hourly13Day,
    Hourly13Night,
    Hourly14Day,
    Hourly14Night,
    Hourly15Day,
    Hourly15Night,
    Hourly16Day,
    Hourly16Night,
    Hourly17Day,
    Hourly17Night,
    Hourly18Day,
    Hourly18Night,
    Hourly19Day,
    Hourly19Night,
    Hourly20Day,
    Hourly20Night,
    Hourly21Day,
    Hourly21Night,
    Hourly22Day,
    Hourly22Night,
    Hourly23Day,
    Hourly23Night,
    Hourly24Day,
    Hourly24Night,
    Hourly25Day,
    Hourly25Night,
    Hourly26Day,
    Hourly26Night,
    Hourly27Day,
    Hourly27Night,
    Hourly28Day,
    Hourly28Night,
    Hourly29Day,
    Hourly29Night,
    Hourly30Day,
    Hourly30Night,
    Hourly31Day,
    Hourly31Night,
    Hourly32Day,
    Hourly32Night,
    Hourly33Day,
    Hourly33Night,
    Hourly34Day,
    Hourly34Night,
    Hourly35Day,
    Hourly35Night,
    WindSpeedSvg1,
    WindSpeedSvg2,
    WindSpeedSvg3,
    WindSpeedSvg4
} from './initImage';
const a = require('@/resource/weather-image/Daily/10_Daily.png');

const ColorConfig = {
    // Temperatuer Max
    // '11-max': 'black',
    '11-max': 'rgb(205, 90, 30)',
    // Temperature min
    // '11-min': '#bdc3bb',
    '11-min': 'rgb(255, 180, 70)',
    // Tempereature advase
    // '11-mean': '#6d736b',
    '11-mean': 'rgb(225, 140, 0)',
    // soil Tempeature
    // '85-mean': 'black',
    '85-mean': 'rgb(204, 136, 0)',
    // Dewpoint
    // '17-mean': '#8B8589',
    '17-mean': 'rgb(139, 69, 19)',
    // soil Moisture
    '144-mean': '#457B9D',
    // Precipitation
    // '61-sum': '#82c8dc',
    '61-sum': '#3333df',
    // wind speed
    '32-mean': '#d759df',
    // Wind gust
    '180-max': '#7B68EE',
    '180-mean': '#7B68EE',
    // Relative Humidity
    '52-mean': '#59b948',

    // new variables
    // Cloud Cover
    '71-mean': '#3B89C7',
    // Wind Direction, 自己给的 mean
    '31-mean': '#14A76C',
    // Radiation and PAR
    '204-mean': '#6B5B95',
    '204-sum': '#6B5B95',
    '5-mean': '#591ec1',
    // Air Pressure, 自己给的 mean
    '1-mean': '#4B0082',
    // Growing Degree Days
    '730-mean': '#FF7F50',
    '730-sum': '#FF7F50',
    // define by self
    // Growing Degree Days
    '2-mean': '#1C3F95',
    // Growing Degree Days
    '3-mean': '#6FC3DF',
    // Growing Degree Days
    '4-mean': '#2980B9',
};


interface GroupedItems {
    [key: string]: IGetHistoricalOrForecastDataResModel[];
}
interface IProp{
    id: string;
    containerHeight?: number;
    echartData?: IGetHistoricalOrForecastDataResModel[],
    translateData?: IAgriAlertTranslateResModel;
    chartsType?: string;
    windOrWeatherSelect?: WindOrWeatherSelectEnum;
    historicalOrForecastType?: string;
}
const PreviewChart = (prop:IProp)=>{

    const {
        id,
        echartData,
        translateData,
        chartsType,
        containerHeight = 490,
        windOrWeatherSelect = 0,
        historicalOrForecastType
    } = prop;
    const [modalOpen,setModalOpen] = useState(true);
    const forecastChartRef = useRef<HTMLDivElement>(null);



    const getOffSet = (index:number,isRadition?: boolean)=>{
        let tmpOffSet = 0;
        const tmpWidth = 50;
        // const tmpWidth = 50;
        tmpOffSet = index * tmpWidth + (isRadition ? 20 : 0);
        return tmpOffSet;
    };

    const getFontOrSeriesColor = (code:number,count:number,aggregation?: string,type?:string)=>{
        let tmpColor = '';
        const tmpAggregaton = aggregation || 'mean';
        if(type === 'series'){
            const tmpKey = `${code}-${tmpAggregaton}`;
            tmpColor = ColorConfig[tmpKey];
        }
        else{
            const tmpKey = `${code}-${tmpAggregaton}`;
            switch(code){
                case 61:
                    tmpColor = ColorConfig[tmpKey]; // Precipitation
                    break;
                case 144:
                    tmpColor = ColorConfig[tmpKey]; // soil Moisture
                    break;
                // new historical
                case 31:
                    tmpColor = ColorConfig[tmpKey]; // Wind Direction
                    break;
                // Radiation and PAR
                case 204:
                case 5:
                    tmpColor = count > 1 ? 'black' : ColorConfig[tmpKey]; // Radiation and PAR
                    break;
                case 1:
                    tmpColor = ColorConfig[tmpKey]; // Air Pressure
                    break;
                case 730:
                    tmpColor = ColorConfig[tmpKey]; // Growing Degree Days
                    break;
                // Percentage, %
                case 52: // Relative Humidity
                case 71: // Cloud Cover
                case 2: // Precipitation Risk
                case 3: // Show Risk
                case 4: // Thunderstorm Risk
                    tmpColor = count > 1 ? 'black' : ColorConfig[tmpKey]; // Relative Humidity
                    break;
                    // wind speed and widn gust
                case 32:
                case 180:
                    tmpColor = count > 1 ? 'black' : ColorConfig[tmpKey];
                    break;
                // Temperature, Soil Temperature, and Dewpoint
                case 85:
                    tmpColor = count > 1 ? 'black' : ColorConfig[tmpKey];
                    break;
                case 17:
                    tmpColor = count > 1 ? 'black' : ColorConfig[tmpKey];
                    break;
                case 11:
                    tmpColor = count > 1 ? 'black' : ColorConfig[tmpKey];
                    break;
            }
        }
        return tmpColor;
    };
    const getName = (code:number,variablesName:string)=>{
        let tmpName = '';
        switch(code){
            case 61:
                tmpName = variablesName;
                break;
            case 144:
                tmpName = variablesName;
                break;
            // new historical
            case 31:
                tmpName = variablesName;
                break;
            case 204:
            case 5:
                // tmpName = variablesName;
                tmpName = translateData?.par || 'PAR';
                break;
            case 1:
                tmpName = variablesName;
                break;
            case 730:
                tmpName = variablesName;
                break;
            // Percentage, %
            case 52: // Relative Humidity
            case 71: // Cloud Cover
            case 2: // Precipitation Risk
            case 3: // Show Risk
            case 4: // Thunderstorm Risk
                tmpName = translateData?.percentage || 'Percentage';
                break;
            case 32:
            case 180:
                tmpName = translateData?.speed || 'Speed';
                break;
            case 85:
            case 11:
            case 17:
                tmpName = translateData?.temperature || 'Temperature';
                break;
        }
        return tmpName;
    };

    const generateHourlyDates = (dates: string[],type:string) => {
        const hourlyDates = [];
        for (let i = 0; i < dates.length; i++) {
            if(type === AgregationEnum.HOURLY){
                for (let j = 0; j < 24; j++) {
                    const hour = j.toString().padStart(2,'0');
                    const label = `${dates?.[i]} ${hour}:00`;
                    // const label = `${dates?.[i]}`;
                    hourlyDates.push(label);
                }
            }
            if(type === AgregationEnum.EIGHTHOURLY){
                for (let j = 0; j < 3; j++) {
                    const tmpJ = j * 8;
                    const hour = tmpJ.toString().padStart(2,'0');
                    const label = `${dates?.[i]} ${hour}:00`;
                    hourlyDates.push(label);
                }
            }
        }
        return hourlyDates;
    };

    const expandHourlyValues = (hourlyValues: string[][]) => {
        return hourlyValues?.flat();
    };

    const getWindImageWidthByUnit = (value: string):{image:string, width:number}=>{
        let tmpWidth = 12;
        let tmpImage = WindSpeedSvg1;
        if(value === '0') tmpWidth = 0;
        if(value === '1') tmpWidth = 12;
        if(value === '2'){
            tmpWidth = 16;
            tmpImage = WindSpeedSvg2;
        }
        if(value === '3'){
            tmpWidth = 20;
            tmpImage = WindSpeedSvg3;
        }
        if(value === '4') {
            tmpWidth = 24;
            tmpImage = WindSpeedSvg4;
        }
        return { image: tmpImage, width: tmpWidth };
    };

    const getDailyImageLeft = (
        itemContainerWidth: number,
        index:number,
        itemWidth: number,
        gridLeft: number
    )=>{
        let tmpLeft = 0;
        tmpLeft = index * itemContainerWidth + itemContainerWidth / 2 - itemWidth / 2 ;
        return tmpLeft + gridLeft;
    };

    const get8HourlyImageLeft = (
        itemContainerWidth: number,
        index:number,
        itemWidth: number,
        gridLeft: number
    )=>{
        // 计算天索引（每天有 3 个元素）
        const dayIndex = Math.floor(index / 3);

        // 计算当天内的索引（0、1 或 2）
        const innerIndexWithinDay = index % 3;

        // 每天的总宽度分为三部分，每部分为 itemContainerWidth / 3
        const dailyUnitWidth = itemContainerWidth / 3;

        // 当前天内的偏移量
        const innerOffset = innerIndexWithinDay * dailyUnitWidth + dailyUnitWidth / 2 - itemWidth / 2;

        // 整体偏移量
        const totalOffset = dayIndex * itemContainerWidth + innerOffset + gridLeft;

        return totalOffset;
    };

    const getGraphicOptions = (type: string, contentWidth:number,data?: IGetHistoricalOrForecastDataResModel[]) => {
        let tmpDays = 7;
        if(echartData?.length >= 1){
            tmpDays = echartData?.[0]?.date?.length || 7;
        }
        const gridLeftInPixels = (0.04) * 822;
        if (type === AgregationEnum.DAILY) {
            // Process for Daily
            const tmpContentWidth = contentWidth / tmpDays;
            let tmpWindTop = 0;
            let tmpWeatherTop = 0;
            if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVENONE){
                tmpWindTop = 0;
                tmpWeatherTop = 0;
            }
            else if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVEWIND){
                tmpWindTop = 20;
                tmpWeatherTop = 0;
            }
            else if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVEWEATHER){
                tmpWindTop = 0;
                tmpWeatherTop = 20;
            }
            else if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVEBOTH){
                tmpWindTop = 70;
                tmpWeatherTop = 20;
            }
            const graphicOptions = data
                ?.map((item, index) => {
                    // 使用 flatMap 替代 map，避免嵌套数组
                    return item?.values
                        ?.map((innerItem, innerIndex) => {
                            const tmpSplitValue = innerItem?.split('_');
                            const tmpRotato = Number(tmpSplitValue?.[1] || 0);
                            const { image, width } = getWindImageWidthByUnit(tmpSplitValue?.[0] || '0');
                            let tmpWeatherImage = null;
                            let tmpWidth = width;
                            if(item?.code === 6){
                                tmpWeatherImage = getWeatherImage(true,innerItem);
                                tmpWidth = 40;
                            }
                            return {
                                type: 'image',
                                style: {
                                    image: item?.code === 5 ? image : tmpWeatherImage,
                                    width: tmpWidth,
                                    height: tmpWidth
                                },
                                top: item?.code === 5 ? tmpWindTop : tmpWeatherTop,
                                rotation: item?.code === 5 ? -(tmpRotato * Math.PI / 180) : 0,

                                // left: item?.code === 5 ? innerIndex * tmpContentWidth + (tmpContentWidth) : Math.max(innerIndex * tmpContentWidth + (tmpContentWidth) - 20,0),
                                left: getDailyImageLeft(tmpContentWidth,innerIndex,tmpWidth,gridLeftInPixels),
                                z: 10
                            };
                        })
                        ?.flat(); // 确保内层数组扁平化
                })
                ?.flat(); // 确保外层数组扁平化

            console.log('lanxue test graphicOptions', graphicOptions);
            console.log('lanxue test graphicOptions contentWidth', contentWidth);
            console.log('lanxue test graphicOptions tmpContentWidth', tmpContentWidth);
            return graphicOptions;
        }
        if (type === AgregationEnum.EIGHTHOURLY) {
            // Process for 8-Hourly
            const tmpContentWidth = contentWidth / tmpDays;
            let tmpWindTop = 0;
            let tmpWeatherTop = 0;
            if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVENONE){
                tmpWindTop = 0;
                tmpWeatherTop = 0;
            }
            else if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVEWIND){
                tmpWindTop = 20;
                tmpWeatherTop = 0;
            }
            else if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVEWEATHER){
                tmpWindTop = 0;
                tmpWeatherTop = 20;
            }
            else if(windOrWeatherSelect === WindOrWeatherSelectEnum.HAVEBOTH){
                tmpWindTop = 70;
                tmpWeatherTop = 20;
            }
            const graphicOptions = data
                ?.map((item, index) => {
                    // 使用 flatMap 替代 map，避免嵌套数组
                    return item?.hourlyValues
                        ?.map((innerItem, innerIndex) => {
                            return innerItem?.map((hourlyItem, hourlyIndex) => {
                                const tmpSplitValue = hourlyItem?.split('_');
                                const tmpRotato = Number(tmpSplitValue?.[1] || 0);
                                const { image, width } = getWindImageWidthByUnit(tmpSplitValue?.[0] || '0');
                                let tmpWeatherImage = null;
                                let tmpWidth = width;
                                if(item?.code === 6){
                                    tmpWeatherImage = getWeatherImage(false,hourlyItem,hourlyIndex);
                                    tmpWidth = 30;
                                }
                                return {
                                    type: 'image',
                                    style: {
                                        image: item?.code === 5 ? image : tmpWeatherImage,
                                        width: tmpWidth,
                                        height: tmpWidth
                                    },
                                    top: item?.code === 5 ? tmpWindTop : tmpWeatherTop,
                                    rotation: item?.code === 5 ? -(tmpRotato * Math.PI / 180) : 0,
                                    // left: item?.code === 5 ? (innerIndex * 3 + hourlyIndex) * tmpContentWidth + (tmpContentWidth ) + 7 + 9:
                                    //     Math.max((innerIndex * 3 + hourlyIndex) * tmpContentWidth + (tmpContentWidth ) - 5 + 9,0),

                                    left: get8HourlyImageLeft(
                                        tmpContentWidth, // 每天的容器宽度
                                        hourlyIndex + 3 * innerIndex, // 全局索引
                                        tmpWidth, // 元素的宽度
                                        gridLeftInPixels // grid.left 的像素值
                                    ),
                                    z: 10,
                                    // origin: [0,0]
                                    // originX: 15,
                                    // originY: 15
                                };
                            }).flat();
                        })
                        ?.flat(); // 确保内层数组扁平化
                })
                ?.flat(); // 确保外层数组扁平化

            console.log('lanxue test graphicOptions', graphicOptions);
            return graphicOptions;
        }
        return []; // 如果 type 不是 DAILY，返回空数组
    };

    console.log('lanxue erhcarts data',echartData);
    const changeOption = (type:string)=>{
        const tmpLegend:string[] = [];
        let tmpXAxis:string[] = [];
        const tmpYAxis:any[] = [];
        const tmpSeries:any[] = [];

        const echartDataForChart = echartData?.filter( x => x.unit !== 'image');
        const echartDataForImage = echartData?.filter( x => x.unit === 'image');

        const groupedByUnit = echartDataForChart?.reduce((accumulator, currentValue) => {
            // 检查accumulator中是否已经有当前unit的数组
            if (!accumulator[currentValue.unit]) {
                // 如果没有，则初始化该unit的数组
                accumulator[currentValue.unit] = [];
            }
            // 将当前对象添加到对应unit的数组中
            accumulator[currentValue.unit].push(currentValue);
            // 返回accumulator供下一次迭代使用
            return accumulator;
        }, {} as GroupedItems);

        let isRaditionFlag = false;
        Object.values(groupedByUnit)?.forEach((item:any,index)=>{
            // const tmpFontColor = getFontColor(item?.[0]?.code,item?.length);
            const tmpUnit = item?.[0]?.unit;
            const tmpFontColor = getFontOrSeriesColor(item?.[0]?.code,item?.length,item?.[0]?.aggregation,'font');
            const tmpName = `${getName(item?.[0]?.code,item?.[0]?.variable)} (${tmpUnit})`;

            const isRadition = (item?.length === 1 &&
                (item?.[0]?.code === 204 || item?.[0]?.code === 5)
            ) ? true : false;

            tmpYAxis.push({
                type: 'value',
                name: tmpName,
                // position: (index % 2 === 0) ? 'left' : 'right',
                position: 'right',
                offset: getOffSet(index,isRaditionFlag),
                // nameGap: 35,
                nameGap: isRadition ? 55 : 35,
                nameRotate: 90,
                nameLocation: 'middle',
                nameTextStyle:{
                    color: tmpFontColor,
                    fontFamily: '\'Noto-Sans-Regular\', sans-serif',
                    fontSize: 11
                },
                axisTick: {
                    show: true
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: tmpFontColor,
                    }
                },
                // min: tmpUnit === '°C' ? -10 : (tmpUnit === '°F' ? 14 : null),
                // max: tmpUnit === '°C' ? +40 : (tmpUnit === '°F' ? 104 : null),
                // alignTicks: true, // 对齐刻度
                // data: Array.from({ length: 24 }, (_, i) => ({ value: i -3 })), // y 轴数据
                data: (item?.[0]?.unit === 'image') ? Array.from({ length: 24 }, (_, i) => ({ value: i })) : null, // y 轴数据
            });
            if(isRadition) isRaditionFlag = true;

            if(type === AgregationEnum.DAILY){
                if(historicalOrForecastType === HistoricalOrForecastEnum.FORECAST){
                    item?.forEach((innerItem,innerIndex)=>{
                        tmpLegend.push(innerItem?.variable);
                        tmpSeries.push({
                            name: innerItem?.variable,
                            type: (innerItem?.unit === 'image') ? 'scatter' :
                                (innerItem?.unit === 'mm') ? 'bar' : 'line',
                            label: {
                                show: (innerItem?.unit === 'mm') ? true : false,
                                position: 'top'
                            },
                            lineStyle: {
                                type: innerItem?.code === 85 ? 'dashed' : 'solid'
                            },
                            yAxisIndex: index,
                            smooth: true,
                            color: getFontOrSeriesColor(innerItem?.code,item?.length,innerItem?.aggregation,'series'),
                            // data: innerItem?.unit === 'image' ? getSymbolForWindImage(innerItem.values ): innerItem.values
                            data: innerItem.values,
                            showSymbol: true, // 确保每个点都有图标
                            symbol: 'circle', // 设置图标样式
                            symbolSize: 7 // 设置图标大小
                        });
                    });
                }
                else if(historicalOrForecastType === HistoricalOrForecastEnum.HISTORICAL){
                    item?.forEach((innerItem,innerIndex)=>{
                        tmpLegend.push(innerItem?.variable);
                        tmpSeries.push({
                            name: innerItem?.variable,
                            type: (innerItem?.unit === 'image') ? 'scatter' :
                                (innerItem?.unit === 'mm') ? 'bar' : 'line',
                            label: {
                                show: (innerItem?.unit === 'mm') ? true : false,
                                position: 'top'
                            },
                            lineStyle: {
                                type: innerItem?.code === 85 ? 'dashed' : 'solid'
                            },
                            yAxisIndex: index,
                            color: getFontOrSeriesColor(innerItem?.code,item?.length,innerItem?.aggregation,'series'),
                            data: innerItem.values,
                            showSymbol: true, // 确保每个点都有图标
                            symbol: 'circle', // 设置图标样式
                            symbolSize: 7 // 设置图标大小
                        });
                    });
                }

            }
            else if(type === AgregationEnum.EIGHTHOURLY){
                item?.forEach((innerItem, innerIndex) => {
                    tmpLegend.push(innerItem?.variable);
                    tmpSeries.push({
                        name: innerItem?.variable,
                        type: innerItem?.code === 61 ? 'bar' : 'line',
                        label: {
                            show: (innerItem?.unit === 'mm') ? true : false,
                            position: 'top'
                        },
                        smooth: true,
                        yAxisIndex: index,
                        color: getFontOrSeriesColor(innerItem?.code, item?.length, innerItem?.aggregation, 'series'),
                        data: expandHourlyValues(innerItem.hourlyValues),
                        showSymbol: true, // 确保每个点都有图标
                        symbol: 'circle', // 设置图标样式
                        symbolSize: 7 // 设置图标大小
                    });
                });
            }
            else if(type === AgregationEnum.HOURLY){
                item?.forEach((innerItem, innerIndex) => {
                    tmpLegend.push(innerItem?.variable);
                    tmpSeries.push({
                        name: innerItem?.variable,
                        // type: innerItem?.code === 61 ? 'bar' : 'scatter',
                        type: innerItem?.code === 61 ? 'bar' : 'line',
                        smooth: true,
                        yAxisIndex: index,
                        color: getFontOrSeriesColor(innerItem?.code, item?.length, innerItem?.aggregation, 'series'),
                        data: expandHourlyValues(innerItem.hourlyValues),
                        showSymbol: false, // 确保每个点都有图标
                        symbol: 'circle', // 设置图标样式
                        symbolSize: 7 // 设置图标大小
                    });
                });
            }

        });

        if(type === AgregationEnum.DAILY){
            echartDataForChart?.forEach((item,index)=>{
                tmpXAxis = item.date;
            });
        }
        else if(type === AgregationEnum.EIGHTHOURLY){
            echartDataForChart?.forEach((item,index)=>{
                tmpXAxis = generateHourlyDates(item.date,AgregationEnum.EIGHTHOURLY);
            });
        }
        else if(type === AgregationEnum.HOURLY){
            echartDataForChart?.forEach((item,index)=>{
                tmpXAxis = generateHourlyDates(item.date,AgregationEnum.HOURLY);
            });
        }

        let finalGridRight = 0;
        if(isRaditionFlag){
            finalGridRight = getOffSet(Object.values(groupedByUnit)?.length) + 20;
        }
        else{
            finalGridRight = getOffSet(Object.values(groupedByUnit)?.length) ;
        }

        let tmpGraphic = [];
        if(echartDataForImage?.length >= 1){
            if(Object.values(groupedByUnit)?.length === 1){
                // tmpGraphic = getGraphicOptions(type,822 - finalGridRight - 50,echartDataForImage);
                tmpGraphic = getGraphicOptions(type,822 - finalGridRight - 822*0.04,echartDataForImage);
            }
            else{
                // tmpGraphic = getGraphicOptions(type,822 - finalGridRight,echartDataForImage);
                tmpGraphic = getGraphicOptions(type,822 - finalGridRight - 822*0.04,echartDataForImage);
            }

        }
        // set Option
        const option = {
            grid: {
                containLabel: false,
                // left: '4%',
                left: 32.88,
                right: finalGridRight,
                bottom: '16%',
                width: 822 - 32.88 - finalGridRight,
                // bottom: '14%' + 20,
                // top:  40 + windOrWeatherSelect,
                top:  20 + windOrWeatherSelect,
                // height: 420,
                height: 400,
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                }
            },
            legend: {
                data: tmpLegend,
                // top: type === AgregationEnum.DAILY ? 440 + windOrWeatherSelect : 510 + windOrWeatherSelect
                top: type === AgregationEnum.EIGHTHOURLY ? 510 + windOrWeatherSelect : 450 + windOrWeatherSelect
                // top: type === AgregationEnum.DAILY ? 440 : 510/
            },
            xAxis: {
                data: tmpXAxis,
                axisTick: {
                    show: true,
                    interval: (historicalOrForecastType === HistoricalOrForecastEnum.HISTORICAL) ? undefined :
                        ((type === AgregationEnum.HOURLY) ? 7 : 0) ,
                    // interval: 1
                },
                axisLabel: {
                    rotate: (historicalOrForecastType === HistoricalOrForecastEnum.HISTORICAL) ? undefined :
                        ((type === AgregationEnum.EIGHTHOURLY) ? -45 : 0) ,
                    interval: (historicalOrForecastType === HistoricalOrForecastEnum.HISTORICAL) ? undefined :
                        ((type === AgregationEnum.HOURLY) ? 3 : 0) ,
                    formatter: (type === AgregationEnum.HOURLY) ?
                        (value, index)=> {
                            const splitDate = value.split(' ');
                            if(splitDate?.[1] === '12:00'){
                                return splitDate?.[0];
                            }
                            else{
                                return null;
                            }
                            // return value + 'kg';
                        }
                        : undefined
                },
                // axisLabel: {
                //     rotate: (type === AgregationEnum.HOURLY || type === AgregationEnum.EIGHTHOURLY) ? -45 : 0,
                //     interval: type === AgregationEnum.HOURLY ? 7 :
                //         ( type ? 0 : undefined),
                // },
                splitLine: {
                    // show: type === AgregationEnum.HOURLY ? true : false,
                    show: historicalOrForecastType === HistoricalOrForecastEnum.HISTORICAL ? false : true,
                    interval: type === AgregationEnum.HOURLY ? 7 : 0,
                    lineStyle: {
                        type: 'solid',
                        color: 'lightgrey',
                        fontSize: 10
                    }
                },
            },
            yAxis: tmpYAxis,
            series: tmpSeries,
            graphic: tmpGraphic
        };
        return option;
    };

    // set echart options
    useLayoutEffect(() => {
        if (echartData?.length >= 1) {
            const initChart = () => {
                if (forecastChartRef.current) {
                    const forecastChart = echarts.init(forecastChartRef.current);
                    const option = {
                        'grid': {
                            'containLabel': true,
                            'left': '11%',
                            'right': '10%',
                            'bottom': '12%',
                            'top': 10,
                            'height': 420
                        },
                        'tooltip': {
                            'trigger': 'axis',
                            'axisPointer': {
                                'type': 'cross'
                            }
                        },
                        'legend': {
                            'data': [
                                'Soil Moisture'
                            ],
                            'top': 430
                        },
                        'xAxis': {
                            'type': 'category',
                            'data': [
                                '09/02/2024',
                                '09/03/2024',
                                '09/04/2024',
                                '09/05/2024',
                                '09/06/2024',
                                '09/07/2024',
                                '09/08/2024'
                            ]
                        },
                        'yAxis': [
                            {
                                'type': 'value',
                                'name': 'Soil Moisture',
                                'position': 'left',
                                'offset': 0,
                                'nameGap': 25,
                                'nameRotate': 90,
                                'nameLocation': 'middle',
                                'nameTextStyle': {
                                    'color': '#0d44dd',
                                    'fontFamily': 'Noto-Sans-Regular, sans-serif',
                                    'fontSize': 11
                                },
                                'axisTick': {
                                    'show': true
                                },
                                'axisLine': {
                                    'show': true
                                }
                            }
                        ],
                        'series': [
                            {
                                'name': 'Soil Moisture',
                                'type': 'line',
                                'yAxisIndex': 0,
                                'data': [
                                    -1, -1, -1, -1, -1, -1, -1
                                ],
                                'lineStyle': {
                                    'color': 'black',
                                    'width': 1,
                                    'type': 'dashed'
                                }
                            }
                        ],
                        'graphic': (function () {
                            const dates = [
                                '09/02/2024',
                                '09/03/2024',
                                '09/04/2024',
                                '09/05/2024',
                                '09/06/2024',
                                '09/07/2024',
                                '09/08/2024'
                            ];
                            const graphicElements = dates.map((date, index) => {
                                let tmpImage = WindSpeedSvg1;
                                // let tmpImage = '@/resource/windspeed-svg/windImage1.svg';
                                if(index === 2){
                                    tmpImage = WindSpeedSvg2;
                                    // tmpImage = '@/resource/windspeed-svg/windImage2.svg';
                                }
                                if(index === 3){
                                    tmpImage = WindSpeedSvg3;
                                    // tmpImage = '@/resource/windspeed-svg/windImage3.svg';
                                }
                                if(index === 4){
                                    tmpImage = WindSpeedSvg4;
                                    // tmpImage = '@/resource/windspeed-svg/windImage4.svg';
                                }
                                return {
                                    type: 'image',
                                    style: {
                                        image: tmpImage,// 替换为你的 SVG 图标路径
                                        // image: tmpImage,// 替换为你的 SVG 图标路径
                                        width: 20,
                                        height: 20
                                    },
                                    // position: [index * (100 / dates.length) + '%', '0%'] // 根据日期位置计算图标位置
                                    top: 60,
                                    rotation: -(10 * index * Math.PI / 180),
                                    left: index * 100 + 10 // 根据日期位置计算图标位置
                                };
                            });
                            return graphicElements;
                        })()
                    };

                    if(echartData?.length >= 1){
                        if(chartsType === AgregationEnum.DAILY){
                            // const tmpOption = option;
                            const tmpOption = changeOption(AgregationEnum.DAILY);
                            console.log('lanxue daily options:',tmpOption);
                            forecastChart.setOption(tmpOption);
                        }
                        else if(chartsType === AgregationEnum.EIGHTHOURLY){
                            // const tmpOption = option;
                            const tmpOption = changeOption(AgregationEnum.EIGHTHOURLY);
                            console.log('lanxue 8-hourly options:',tmpOption);
                            forecastChart.setOption(tmpOption);
                        }
                        else if(chartsType === AgregationEnum.HOURLY){
                            // const tmpOption = option;
                            const tmpOption = changeOption(AgregationEnum.HOURLY);
                            console.log('lanxue hourly options:',tmpOption);
                            forecastChart.setOption(tmpOption);
                        }
                        else{
                            // const tmpOption = option;
                            const tmpOption = changeOption(null);
                            console.log('lanxue test graphicOptions options:',tmpOption);
                            forecastChart.setOption(tmpOption);
                        }

                    }
                    else{
                        forecastChart.setOption(option);
                    }
                }
            };

            // 使用 requestAnimationFrame 确保 DOM 更新后执行
            requestAnimationFrame(initChart);

            return () => {
                // 清理函数，确保图表被销毁
                if (forecastChartRef.current) {
                    const chartInstance = echarts.getInstanceByDom(forecastChartRef.current);
                    if (chartInstance) {
                        chartInstance.dispose();
                    }
                }
            };
        }
    }, [echartData]);

    return(
        <>
            <div id={id}
                ref={forecastChartRef}
                // style={{width:'822px',height:'274px'}}></div>
                style={{width:'822px',height:`${containerHeight}px`}}></div>
        </>
    );

};


export default React.memo(PreviewChart);